import * as React from 'react';
import Area from '@/components/Area';
import { Canvas, GroupProps, useGraph } from '@react-three/fiber';
import { OrbitControls, useAnimations, useGLTF, useTexture, Text } from '@react-three/drei';
import glb from './stacy.glb';
import jpg from './stacy.texture.glb';
import { SkeletonUtils } from 'three-stdlib';
import { SkinnedMesh, Vector4 } from 'three';

function Model({ initialPose, ...props }: { initialPose: number } & GroupProps) {
  const { scene, animations } = useGLTF(glb);
  const clone = React.useMemo(() => SkeletonUtils.clone(scene), [scene]);
  const { nodes } = useGraph(clone);
  const stacy = nodes.stacy as SkinnedMesh;
  const texture = useTexture(jpg);
  texture.flipY = false;

  // animation index
  const [index, setIndex] = React.useState(initialPose);

  // Extract animation actions
  const { ref, names, actions } = useAnimations(animations);
  const name = names[index];

  // Change animation when the index changes
  React.useEffect(() => {
    const action = actions[name];
    // Reset and fade in animation after an index has been changed
    action?.reset().fadeIn(0.5).play();
    // In the clean-up phase, fade it out
    return () => {
      action?.fadeOut(0.5);
    };
  }, [actions, name]);

  // console.log('Model', { ref, names, actions });
  return (
    <group {...props}>
      <group
        rotation={[Math.PI / 2, 0, 0]}
        scale={[0.01, 0.01, 0.01]}
        onClick={() => setIndex((index + 1) % names.length)}
      >
        <primitive object={nodes.mixamorigHips} />
        <skinnedMesh
          ref={(r) => (ref.current = r)}
          castShadow
          receiveShadow
          geometry={stacy.geometry}
          skeleton={stacy.skeleton}
        >
          <meshStandardMaterial map={texture} />
        </skinnedMesh>
      </group>
      <Text position={[0, 2, -1]} color={'black'} anchorX="center" anchorY="middle">
        {name}
      </Text>
    </group>
  );
}

export type Props = {};

function App02(props: Props) {
  const {} = props;

  return (
    <Area css={{ height: '400px' }}>
      {() => (
        <>
          <Canvas shadows camera={{ position: [1, 1.5, 2.5], fov: 50, viewport: new Vector4(0, 600, 0, 0) }}>
            {/* <Canvas shadows> */}
            <ambientLight intensity={0.5} />
            <directionalLight
              position={[-5, 5, 5]}
              castShadow
              shadow-mapSize-width={1024}
              shadow-mapSize-height={1024}
            />
            {/* <Bounds fit clip observe> */}
            {/* <PivotControls>
              <mesh>
                <boxGeometry args={[1, 1, 1]} />
              </mesh>
            </PivotControls> */}
            <group position={[0, -1, 0]}>
              <React.Suspense fallback={null}>
                <Model initialPose={8} position={[0, 0, 0]} />
              </React.Suspense>
            </group>
            {/* </Bounds> */}
            <mesh rotation={[-0.5 * Math.PI, 0, 0]} position={[0, -1, 0]} receiveShadow>
              <planeGeometry args={[10, 10, 1, 1]} />
              <shadowMaterial transparent opacity={0.2} />
            </mesh>
            <gridHelper />
            <axesHelper />
            {/* <perspectiveCamera position={[1, 1.5, 2.5]} fov={50} /> */}
            <OrbitControls makeDefault />
          </Canvas>
        </>
      )}
    </Area>
  );
}

export default React.memo(App02);
